// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"622":"b9c611ec","977":"85430b90"}[chunkId] + ".chunk.js";
};